import { useEffect, useState } from "react";
import { api, naira } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const STATUS = { paid: "bg-emerald-100 text-emerald-800", amount_mismatch: "bg-red-100 text-red-700" };

export const FundingHistory = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/sponsor/payments").then(({ data }) => setData(data)).catch(() => setData({ payments: [], totals: null })); }, []);
  if (!data) return null;
  const t = data.totals;
  return (
    <div className="mt-10 rounded-3xl border border-emerald-100 bg-white p-6" data-testid="sponsor-funding-history">
      <h2 className="font-display font-bold text-lg text-emerald-950">Funding History</h2>
      {t && (
        <div className="mt-3 grid gap-3 grid-cols-1 sm:grid-cols-3">
          {[["Programme value funded", t.programme_value, "value"], ["Programme Delivery & Impact Management Fee (10%)", t.delivery_fee, "fee"], ["Total paid", t.total, "total"]].map(([k, v, id]) => (
            <div key={id} className="rounded-xl border border-emerald-100 p-3" data-testid={`funding-total-${id}`}><div className="text-xs text-gray-500">{k}</div><div className="mt-1 font-bold text-lg text-emerald-950 tabular-nums">{naira(v)}</div></div>
          ))}
        </div>
      )}
      <p className="mt-2 text-xs text-gray-400">Totals include confirmed payments only.</p>
      <div className="mt-3 overflow-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-gray-400 text-xs uppercase"><th className="py-2">Date</th><th>Reference</th><th>Programme</th><th>Programme Value</th><th>Fee (10%)</th><th>Total</th><th>Method</th><th>Status</th></tr></thead>
          <tbody>
            {data.payments.length === 0 && <tr><td colSpan={8} className="py-4 text-gray-500" data-testid="funding-history-empty">No funding payments yet.</td></tr>}
            {data.payments.map((p) => (
              <tr key={p.ref} className="border-t border-gray-100" data-testid={`funding-row-${p.ref}`}>
                <td className="py-2 text-xs">{(p.created_at || "").slice(0, 10)}</td>
                <td className="font-mono text-xs">{p.ref}</td>
                <td className="text-xs">{p.programme_name || "—"}</td>
                <td className="text-xs tabular-nums">{naira(p.programme_value ?? p.total)}</td>
                <td className="text-xs tabular-nums" data-testid={`funding-fee-${p.ref}`}>{naira(p.delivery_fee || 0)}</td>
                <td className="text-xs tabular-nums font-semibold">{naira(p.total)}</td>
                <td className="text-xs">{p.method === "moniepoint" ? "Transfer" : "Paystack"}</td>
                <td><Badge className={STATUS[p.status] || "bg-amber-100 text-amber-800"}>{p.status}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
